/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetUpdates200Response,
  GetVersionPolicy200Response,
} from '../models/index';
import {
    GetUpdates200ResponseFromJSON,
    GetUpdates200ResponseToJSON,
    GetVersionPolicy200ResponseFromJSON,
    GetVersionPolicy200ResponseToJSON,
} from '../models/index';

export interface GetUpdatesRequest {
    version: string;
    platform: GetUpdatesPlatformEnum;
    model?: string;
}

/**
 * 
 */
export class VersionsApi extends runtime.BaseAPI {

    /**
     */
    async getUpdatesRaw(requestParameters: GetUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUpdates200Response>> {
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling getUpdates().'
            );
        }

        if (requestParameters['platform'] == null) {
            throw new runtime.RequiredError(
                'platform',
                'Required parameter "platform" was null or undefined when calling getUpdates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['version'] != null) {
            queryParameters['version'] = requestParameters['version'];
        }

        if (requestParameters['platform'] != null) {
            queryParameters['platform'] = requestParameters['platform'];
        }

        if (requestParameters['model'] != null) {
            queryParameters['model'] = requestParameters['model'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/versions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUpdates200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getUpdates(requestParameters: GetUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUpdates200Response> {
        const response = await this.getUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVersionPolicyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetVersionPolicy200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/versions/version-policy`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetVersionPolicy200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getVersionPolicy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetVersionPolicy200Response> {
        const response = await this.getVersionPolicyRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetUpdatesPlatformEnum = {
    Windows: 'windows',
    Win32: 'win32',
    Bundle: 'bundle',
    Android: 'android',
    Ios: 'ios',
    Apk: 'apk'
} as const;
export type GetUpdatesPlatformEnum = typeof GetUpdatesPlatformEnum[keyof typeof GetUpdatesPlatformEnum];
